/**
 * Generates a high-entropy random unique order ID with format ORD-XXXXXXXXXX
 * The suffix consists of 10 random alphanumeric characters (A-Z, 0-9).
 * Entropy: 36^10 = 3.656 Quadrillion combinations.
 */
export function generateOrderId(): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let orderId = '';
  
  for (let i = 0; i < 10; i++) {
    orderId += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return `ORD-${orderId}`;
}

/**
 * Format price as currency (BDT / Taka)
 */
export function formatPrice(amount: number): string {
  return `৳${amount.toFixed(2)}`;
}

/**
 * Format date to local locale string
 */
export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}
